import React, { useRef } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

interface MyEditorProps {
  values: { description?: string }; 
  setFieldValue: (field: string, value: any) => void;
}

const MyEditor: React.FC<MyEditorProps> = ({ values, setFieldValue }) => {
  const quillRef = useRef<ReactQuill>(null);
  const MAX_CHARACTERS = 500; // حداکثر تعداد کاراکترها

  const handleChange = (value: string) => {
    if (value.length <= MAX_CHARACTERS) {
      setFieldValue('description', value);
    }
  };

  const handleBlur = () => {
    if (quillRef.current) {
      const quillEditor = quillRef.current.getEditor();
      // حذف فرمت‌های اضافی
      quillEditor.format('direction', 'rtl');
      quillEditor.format('color', false);
      quillEditor.format('background', false);
    }
  };

  return (
    <div style={{ padding: '8px', maxWidth: '900px' }}>
      <style>
        {`
          .ql-editor {
            direction: rtl;
            text-align: right;
            font-family: 'Yekan', sans-serif;
          }
          .ql-editor ol {
            list-style-type: decimal;
            padding-left: 20px;
          }
          .ql-editor ul {
            list-style-type: disc;
            padding-left: 20px;
          }
          .ql-toolbar.ql-snow {
            display: flex;
            flex-wrap: nowrap;
            overflow-x: auto;
          }
          .ql-toolbar.ql-snow .ql-formats {
            margin-right: 5px;
            display: flex;
            align-items: center;
          }
          .ql-toolbar.ql-snow .ql-formats > * {
            margin-right: 5px;
          }
          .ql-container, .ql-editor {
            font-family: 'Yekan', sans-serif;
          }
          .ql-editor::placeholder {
            font-family: 'Yekan', sans-serif;
          }
        `}
      </style>
      <ReactQuill
        ref={quillRef}
        value={values?.description || ""}
        onChange={handleChange}
        onBlur={handleBlur} // اضافه کردن onBlur
        modules={{
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'color': [] }, { 'background': [] }],
            ['link'],
          ],
        }}
        formats={[
          'bold', 'italic', 'underline', 'strike',
          'list', 'bullet', 'indent',
          'direction',
          'color', 'background',
          'link',
        ]}
        placeholder="توضیحات را وارد کنید..."
      />
    </div>
  );
};

export default MyEditor;
